// Build information, automatically generated by `ng-info`
const build = {
    version: "25.2.0-SNAPSHOT",
    timestamp: "Tue Nov 03 2026 18:04:42 GMT+0100 (Central European Standard Time)",
    message: null,
    git: {
        user: null,
        branch: "HEAD",
        hash: "6f9ef6",
        fullHash: "6f9ef6f2c7cde98f89094a6250012ebc45fd9b61"
    }
};

export default build;